import { render, staticRenderFns } from "./IconMessage.vue?vue&type=template&id=4655b64e&"
import script from "./IconMessage.vue?vue&type=script&lang=ts&"
export * from "./IconMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports